import { StoredObject } from 'services/data/types';

export const generateFakeIds = <T extends Record<string, any>>(list: T[]): StoredObject<T>[] =>
  list.map((elem, idx) => ({ ...elem, id: idx.toString() } as StoredObject<T>));
